import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorMessagePipe } from '@app/shared/error-message.pipe';
import { PreventNumberScrollDirective } from '@app/shared/directives/prevent-number-scroll.directive';
import { Calendar, CircleAlert, LucideAngularModule, XCircle } from 'lucide-angular';
import { NgxMaskDirective } from 'ngx-mask';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-text-input',
  imports: [FormsModule, ReactiveFormsModule, ErrorMessagePipe, LucideAngularModule, NgxMaskDirective, NgClass, PreventNumberScrollDirective],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.css',
  standalone: true,
})
export class TextInputComponent implements OnInit {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() control!: FormControl;
  @Input() mask: string = '';
  @Input() thousandSeparator: string = '';
  @Input() prefix: string = '';
  @Input() required: boolean = false;
  @Input() helpText: string = '';
  @Input() clearable: boolean = false;
  @Input() allowNegativeNumbers: boolean = false;
  @Input() disabled: boolean = false;
  @Input() max?: number;

  constructor() {}

  ngOnInit(): void {
    // Disable/enable control based on input
    if (this.disabled) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }

  hasValue(): boolean {
    const value = this.control?.value;
    return value !== null && value !== undefined && value !== '';
  }

  clearInput(): void {
    const emptyValue = this.type === 'number' ? null : '';
    this.control.setValue(emptyValue);
  }

  protected readonly Object = Object;
  protected readonly Validators = Validators;
  protected readonly Calendar = Calendar;
  protected readonly CircleAlert = CircleAlert;
  protected readonly XCircle = XCircle;
}
